<svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.3332 0.666504L3.99984 7.99984L0.666504 4.6665" stroke="#FFA100" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
